export default {
  id: 12,
  logo: require('@/assets/mcp.svg'),
  name: 'mcp',
  subtitle: 'Concevoir et déployer ses propres serveurs MCP',
  description: {
    details: `Le <b>Model Context Protocol</b> (MCP) est le standard ouvert qui permet
      de connecter les <b>agents IA</b> à vos outils, données et systèmes internes.
      Cette formation explique ce qu'est un serveur MCP, ce qu'il apporte concrètement
      à une équipe de développement, et comment en <b>concevoir un de bout en bout</b> :
      du choix des ressources et outils exposés à la sécurisation et au déploiement.
      À l'issue de la formation, vos développeurs sauront brancher leurs agents IA
      sur votre propre SI.`,
    goals: [
      { id: 1, content: 'Comprendre le Model Context Protocol et son écosystème' },
      { id: 2, content: 'Identifier les cas d\'usage à forte valeur pour son équipe' },
      { id: 3, content: 'Concevoir, développer et tester un serveur MCP' },
      { id: 4, content: 'Sécuriser et déployer un MCP en environnement professionnel' }
    ],
    needs: [
      {
        id: 1,
        title: 'PUBLIC',
        alignItems: 'flex-start',
        items: [
          { id: 1, logo: require('@/assets/training/developer.svg'), name: 'Développeur' },
          { id: 2, logo: require('@/assets/training/projectLeader.svg'), name: 'Tech Lead' },
          { id: 3, logo: require('@/assets/training/architech.svg'), name: 'Architecte' }
        ]
      },
      {
        id: 2,
        title: 'PÉDAGOGIE',
        items: [
          { id: 1, logo: require('@/assets/training/70percent.png'), name: null }
        ]
      },
      {
        id: 3,
        title: 'PRÉ-REQUIS',
        alignItems: 'flex-start',
        items: [
          { id: 1, logo: require('@/assets/training/developer.svg'), name: 'Pratique du développement (TypeScript ou C# recommandé)' },
          { id: 2, logo: require('@/assets/training/tools/claude.svg'), name: 'Première utilisation d\'un agent IA (Claude, Copilot…)' }
        ]
      },
      {
        id: 4,
        title: 'OUTILS',
        alignItems: 'flex-start',
        items: [
          { id: 1, logo: require('@/assets/training/tools/claude.svg'), name: 'Claude Code / Claude Desktop' },
          { id: 2, logo: require('@/assets/training/tools/visualStudioCode.svg'), name: 'VS CODE' },
          { id: 3, logo: require('@/assets/training/tools/npm.svg'), name: 'SDK MCP (TypeScript / C#)' }
        ]
      }
    ],
    time: '2 JOURS',
    price: '300 € HT',
    trainer: 'LOIC'
  },
  program: [
    {
      id: 1,
      title: 'QU\'EST-CE QU\'UN SERVEUR MCP ?',
      items: [
        { id: 1, content: 'Origines et principes du Model Context Protocol' },
        { id: 2, content: 'Anatomie d\'un MCP : resources, tools, prompts' },
        { id: 3, content: 'Transports : stdio, HTTP/SSE, et leurs usages' },
        { id: 4, content: 'Panorama des serveurs MCP existants (GitHub, Slack, bases de données…)' }
      ]
    },
    {
      id: 2,
      title: 'POURQUOI UN MCP DANS SON ÉQUIPE ?',
      items: [
        { id: 1, content: 'Donner à l\'agent un accès contrôlé au SI interne' },
        { id: 2, content: 'Capitaliser sur les outils maison (CLI, scripts, API privées)' },
        { id: 3, content: 'Standardiser les usages et éviter les intégrations ad hoc' },
        { id: 4, content: 'Identifier les cas d\'usage à fort ROI' }
      ]
    },
    {
      id: 3,
      title: 'CONCEVOIR SON PREMIER MCP',
      items: [
        { id: 1, content: 'Choisir le SDK (TypeScript ou C#)' },
        { id: 2, content: 'Définir les resources et les tools à exposer' },
        { id: 3, content: 'Bonnes pratiques de schémas et de descriptions' },
        { id: 4, content: 'Tester son MCP avec l\'Inspector et avec Claude' }
      ]
    },
    {
      id: 4,
      title: 'SÉCURITÉ ET QUALITÉ',
      items: [
        { id: 1, content: 'Authentification, scopes et permissions' },
        { id: 2, content: 'Gestion des secrets et des données sensibles' },
        { id: 3, content: 'Logs, observabilité et audit des appels' },
        { id: 4, content: 'Stratégie de tests pour un MCP' }
      ]
    },
    {
      id: 5,
      title: 'ATELIER : BÂTIR ET DÉPLOYER SON MCP',
      items: [
        { id: 1, content: 'Cas pratique : exposer un outil interne via MCP' },
        { id: 2, content: 'Packaging et distribution à l\'équipe' },
        { id: 3, content: 'Déploiement local vs déploiement partagé (HTTP)' },
        { id: 4, content: 'Intégration dans le workflow quotidien des développeurs' }
      ]
    }
  ]
}
